"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typedIntArrayArbitraryArbitraryBuilder = void 0;

var Converters_1 = require("../../../check/arbitrary/definition/Converters");

var array_1 = require("../../array");

function typedIntArrayArbitraryArbitraryBuilder(constraints, defaultMin, defaultMax, TypedArrayClass, arbitraryBuilder) {
  var generatorName = TypedArrayClass.name;

  var _constraints$min = constraints.min,
      min = _constraints$min === void 0 ? defaultMin : _constraints$min,
      _constraints$max = constraints.max,
      max = _constraints$max === void 0 ? defaultMax : _constraints$max,
      arrayConstraints = __rest(constraints, ["min", "max"]);

  if (min > max) {
    throw new Error("Invalid range passed to ".concat(generatorName, ": min must be lower than or equal to max"));
  }

  if (min < defaultMin) {
    throw new Error("Invalid min value passed to ".concat(generatorName, ": min must be greater than or equal to ").concat(defaultMin));
  }

  if (max > defaultMax) {
    throw new Error("Invalid max value passed to ".concat(generatorName, ": max must be lower than or equal to ").concat(defaultMax));
  }

  return (0, Converters_1.convertFromNext)((0, Converters_1.convertToNext)((0, array_1.array)(arbitraryBuilder({
    min: min,
    max: max
  }), arrayConstraints)).map(function (data) {
    return TypedArrayClass.from(data);
  }, function (value) {
    if (!(value instanceof TypedArrayClass)) throw new Error('Invalid type');
    return _toConsumableArray(value);
  }));
}

exports.typedIntArrayArbitraryArbitraryBuilder = typedIntArrayArbitraryArbitraryBuilder;